import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../../api';
import './StoreInsights.css';

import backIcon from '../../assets/backarrow-icon.png';
import likeIconRed from '../../assets/like-icon-red.png';
import saveIconFilled from '../../assets/save-icon-filled.png';
import cartIcon from '../../assets/cart-icon.png';
import tapIcon from '../../assets/tap-icon.png';

function StoreInsights({ user }) {
  const [insights, setInsights] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchInsights = async () => {
      try {

// ✅ Correct route
const res = await api.get(`/merchants/metrics/${user.username}`);

        console.log('📦 Store insights response:', res.data);
        setInsights(res.data);
      } catch (err) {
        console.error('❌ Failed to load store insights:', err);
      } finally {
        setLoading(false);
      }
    };
    fetchInsights();
  }, [user.username]);

  useEffect(() => {
    if (!insights || !insights.products) return;
    console.log('🛒 Product cart counts:');
    insights.products.forEach(p =>
      console.log(`- ${p.name}: cartCount = ${p.cartCount}`)
    );
    console.log('🛒 Most Added to Cart:', insights.mostAddedToCart);
  }, [insights]);

  if (loading) return <div className="store-insights-screen">Loading insights...</div>;
  if (!insights) return <div className="store-insights-screen">No data available</div>;

  const {
    storeVisits,
    totalClicks,
    mostLiked,
    mostSaved,
    mostAddedToCart,
    mostClicked,
  } = insights;

  const renderItem = (title, item) => (
    <div className="insight-card">
      <div className="insight-label">{title}</div>
      {item ? (
        <div
          className="insight-product"
          onClick={() => navigate(`/product/${item._id || item.id}`)}
        >
          <img src={item.media?.[0]} alt={item.name} className="product-thumbnail" />
          <div>
            <p className="product-name">{item.name}</p>
            <div className="product-metric-insights">
              <img src={likeIconRed} alt="Likes" className="icon-insights" />
              <span>{Array.isArray(item.likes) ? item.likes.length : item.likes || 0}</span>
              {' | '}
              <img src={saveIconFilled} alt="Saves" className="icon-insights" />
              <span>{Array.isArray(item.saves) ? item.saves.length : item.saves || 0}</span>
              {' | '}
              <img src={cartIcon} alt="Cart Adds" className="icon-insights" />
              <span>{typeof item.cartCount === 'number' ? item.cartCount : 0}</span>
              {' | '}

<img src={tapIcon} alt="Clicks" className="icon-insights" />
<span>{typeof item.clickCount === 'number' ? item.clickCount : 0}</span>

            </div>
          </div>
        </div>
      ) : (
        <p className="no-data">No data</p>
      )}
    </div>
  );

  return (
    <div className="store-insights-screen">
      <div className="top-bar">
        <img
          src={backIcon}
          alt="Back"
          className="back-icon"
          onClick={() => navigate(-1)}
        />
        <h2>Store Insights</h2>
      </div>

      <div className="insights-scroll">

<div className="insights-metrics">
  <p><strong>Total Store Visits:</strong> {storeVisits}</p>
  <p><strong>Total Product/Service Clicks:</strong> {totalClicks}</p>
</div>



        {renderItem('Most Liked', mostLiked)}
        {renderItem('Most Saved', mostSaved)}
        {renderItem('Most Added to Cart', mostAddedToCart)}
        {renderItem('Most Clicked', mostClicked)}
      </div>
    </div>
  );
}

export default StoreInsights;
